/** Etiqueta visible del origen del pedido. */
export function orderSourceLabel(source) {
  const raw =
    source != null && typeof source === 'object'
      ? String(source.source || source.id || '')
      : String(source ?? '');
  const s = raw.trim().toLowerCase();
  if (s === 'counter') return 'Pedido en sucursal';
  if (s === 'whatsapp') return 'WhatsApp';
  if (s === 'web') return 'Web';
  if (s === 'telefono') return 'Teléfono (IA)';
  return raw.trim() || '—';
}
